module.exports = __webpack_public_path__ + "static/media/english2.9e6181ac.jpg";